import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, makeStyles } from '@material-ui/core';
import SectionTabs from '../common/SectionTabs';
import SideBySideView from './widgets/assignmentSection/SideBySideViewComponent';
import AssignmentRightContentPanel from './widgets/assignmentSection/AssignmentsRightContentPannel';
import StudentDashboard from '../studentDashboard/StudentDashboard';
import AddEditAssignmentForm from '../AssignmentList/AddEditAssignmentForm';
import Utils from '../../common/utils';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    marginTop: 40,
    background: '#E8E6F3',
    borderRadius: 12,
    padding: 16,
    [theme.breakpoints.down('md')]: {
      marginTop: 20,
      padding: 12,
      borderRadius: 8
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 10,
      padding: 8,
      borderRadius: 6
    }
  },
  contentContainer: {
    marginTop: 10,
    [theme.breakpoints.down('sm')]: {
      marginTop: 8
    }
  }
}));


const AssignmentStudentTabView = ({
  assignments,
  students,
  textInfo,
  tocData,
  onDifficultTopicClick,
  onStudentClick,
  chapterMcqMapping
}) => {
  const dummyData = assignments;
  const dummyUserData = students;
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState(0);
  const [childTabIndex, setChildTabIndex] = useState(0);

  // to handle edit assignment
  const [editingAssignment, setEditingAssignment] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);


  const sortedAssignments = [...dummyData].sort((a, b) => {
    if (a.assignmentComplete && !b.assignmentComplete) return -1;
    if (!a.assignmentComplete && b.assignmentComplete) return 1;

    return 0;
  });

  const completedAssignments = sortedAssignments.filter(item => item.assignmentComplete);
  const upNextAssignments = sortedAssignments.filter(item => !item.assignmentComplete);


  const getInitialSelection = () => {
    if (completedAssignments.length > 0) {
      return completedAssignments[0].id;
    } if (upNextAssignments.length > 0) {
      return upNextAssignments[0].id;
    }

    return dummyData[0]?.id || null;
  };

  const getInitialSelectedStudent = () => (dummyUserData?.length > 0 ? dummyUserData[0]?.id : null);


  const [assignmentSelectedItem, setAssignmentSelectedItem] = useState(getInitialSelection());
  const [studentsSelectedItem, setStudentsSelectedItem] = useState(getInitialSelectedStudent());


  const selectedItem = tabIndex === 0 ? assignmentSelectedItem : studentsSelectedItem;

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const hanldeChildTabIndexChange = (event, newValue) => {
    setChildTabIndex(newValue);
  };

  const handleSelectItem = (itemId) => {
    if (tabIndex === 0) {
      setAssignmentSelectedItem(itemId.id);
    } else {
      setStudentsSelectedItem(itemId.id);
    }
  };

  const selectedAssignment = sortedAssignments.find(item => item.id === selectedItem);
  const selectedStudent = dummyUserData.find(item => item.id === selectedItem);

  // Handle edit button click
  const handleEditClick = () => {
    const currentId = assignmentSelectedItem;
    const currentIndex = assignments.findIndex(item => item.id === currentId);
    const currentAssignment = assignments[currentIndex];
    const mappedAssignment = Utils.mapAssignmentForEdit(currentAssignment);
    setEditingAssignment(mappedAssignment);
    setEditingIndex(currentIndex);
  };

  // Handle edit dialog close
  const handleEditClose = () => {
    setEditingAssignment(null);
    setEditingIndex(null);
  };

  return (
    <Box className={classes.mainContainer}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Box style={{ width: '100%' }}>
          <SectionTabs
            value={tabIndex}
            onChange={handleTabChange}
            variant="primary"
            tab1Label="Assignment"
            tab2Label="Students"
          />
        </Box>
      </Grid>
      <Box className={classes.contentContainer}>
        {tabIndex === 0 && (
          <SideBySideView
            leftItems={sortedAssignments}
            completedItems={completedAssignments}
            upNextItems={upNextAssignments}
            selectedItem={selectedItem}
            onSelect={handleSelectItem}
            renderRightContent={() => (
              <AssignmentRightContentPanel
                childTabIndex={childTabIndex}
                hanldeChildTabIndexChange={hanldeChildTabIndexChange}
                dummayUserData={dummyUserData}
                selectedAssignment={selectedAssignment}
                onEditClick={handleEditClick}
                onDifficultTopicClick={onDifficultTopicClick}
                onStudentClick={onStudentClick}
              />
            )}
          />
        )}
        {tabIndex === 1 && (
          <StudentDashboard
            students={dummyUserData}
            selectedStudent={selectedStudent}
            onSelect={handleSelectItem}
            onDifficultTopicClick={onDifficultTopicClick}
          />
        )}

        {/* Add Edit Assignment Modal */}
        <AddEditAssignmentForm
          open={!!editingAssignment}
          onClose={handleEditClose}
          parentApp="aet"
          editingAssignment={editingAssignment}
          editIndex={editingIndex}
          textInfo={textInfo}
          tocData={tocData}
          chapterMcqMapping={chapterMcqMapping}
        />
      </Box>
    </Box>
  );
};

AssignmentStudentTabView.propTypes = {
  assignments: PropTypes.object,
  students: PropTypes.object,
  textInfo: PropTypes.object,
  tocData: PropTypes.object,
  onDifficultTopicClick: PropTypes.func,
  onStudentClick: PropTypes.func,
  chapterMcqMapping: PropTypes.object
};

AssignmentStudentTabView.defaultProps = {
  assignments: {},
  students: {},
  textInfo: {},
  tocData: {},
  onDifficultTopicClick: () => {},
  onStudentClick: () => {},
  chapterMcqMapping: null
};

export default AssignmentStudentTabView;
